import { render, staticRenderFns } from "./UserTypeTrigger.vue?vue&type=template&id=2b5e8b2e&lang=pug"
import script from "./UserTypeTrigger.vue?vue&type=script&lang=js"
export * from "./UserTypeTrigger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports